/* ===========================================================================
   Mobile menu drawer -- behaviour -- 2026-08-16
   ===========================================================================
   Three jobs, all of them additive. The open/close state machine stays in the
   theme's own bundle; nothing here duplicates it.

     1. Fetch the best-selling strip the first time the drawer is opened, so a
        menu that is never opened costs nothing.
     2. Forward the in-panel close button to the theme's own close control,
        which is hidden by mm-menu.css but still owns the closing.
     3. Move focus onto the in-panel close button when the drawer opens. The
        theme focuses its own control, and focus() on a display:none element is
        a silent no-op -- so without this the drawer opens with focus left
        behind on the page underneath.

   Every failure path here ends with the strip hidden and the menu still fully
   usable: the links are server-rendered and do not depend on this file.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var CANVAS_ID = 'nt_menu_canvas';
  var OPEN_CLASS = 'act_opened';
  var warmed = false;

  function picksUrl() {
    var header = document.getElementById('ntheader');
    return header ? header.getAttribute('data-mm-picks-url') : null;
  }

  /* Warm the HTTP cache while the thumb is still on the hamburger. The drawer
     body is itself lazy-fetched by the theme, so without this the strip is a
     second round trip that starts only after the first one has landed. */
  function warm() {
    if (warmed) return;
    warmed = true;
    var url = picksUrl();
    if (!url) return;
    try {
      fetch(url, { credentials: 'same-origin' }).catch(function () {});
    } catch (err) {
      /* no fetch, no warming -- the real request below still runs */
    }
  }

  function loadPicks(root) {
    var host = root.querySelector('[data-mm-picks]');
    if (!host || host.getAttribute('data-mm-picks-state')) return;

    var url = host.getAttribute('data-mm-picks');
    var body = host.querySelector('[data-mm-picks-body]');
    if (!url || !body) return;

    host.setAttribute('data-mm-picks-state', 'loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        /* Same-origin markup from this theme's own collection.mmpicks
           template, which escapes every merchant-supplied string it prints.
           This is the same trust boundary the theme already relies on for the
           drawer body itself (data-rendert4s in div_html.liquid). */
        body.innerHTML = html;
        /* An empty collection, or a collection whose products are all
           unpublished, renders a row with no cards. A heading over nothing is
           worse than no strip at all. */
        if (!body.querySelector('.mm_pick')) {
          host.style.display = 'none';
          host.setAttribute('data-mm-picks-state', 'empty');
          return;
        }
        host.setAttribute('data-mm-picks-state', 'done');
      })
      .catch(function () {
        host.style.display = 'none';
        host.setAttribute('data-mm-picks-state', 'failed');
      });
  }

  function focusClose(root) {
    var close = root.querySelector('.mm_close');
    if (!close || document.activeElement === close) return;
    window.setTimeout(function () {
      if (root.classList.contains(OPEN_CLASS) && close.isConnected) {
        close.focus({ preventScroll: true });
      }
    }, 80);
  }

  /* ------------------------------------------ log in through Shopflo */

  /* Checkout on this shop is Shopflo, so an account created against Shopify's
     own login is not the account the shopper checks out with. The menu's Login
     therefore has to open Shopflo's phone-and-OTP login, not /account/login.

     Shopflo's own snippet (snippets/shopflo-sso-add-button.liquid) already
     builds a trigger it has wired: #flo-login-button-header-logo. It builds it
     by replacing `.my-account a[href="/account/login"]`, which this theme has —
     but its MOBILE branch looks for `.header__icon-list a[href*="/account"]`,
     a Dawn selector this theme does not have, so on a phone Shopflo never
     replaced anything and the drawer was left pointing at Shopify's login. The
     desktop trigger is nonetheless in the DOM at every width (its wrapper is
     merely hidden by CSS), and .click() works on a hidden element, so the menu
     can hand the tap to the control Shopflo already owns instead of guessing
     at its internals.

     The href stays /account/login on purpose. If Shopflo is disabled, still
     loading, or SSO is switched off, the link does what it always did rather
     than dying silently — the fallback is a working login, not nothing. */
  function shopfloTrigger() {
    if (!window.Shopflo || window.Shopflo.isSsoEnabled !== true) return null;
    return document.getElementById('flo-login-button-header-logo');
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var link = event.target.closest('#nt_menu_canvas a[href*="/account/login"]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    var trigger = shopfloTrigger();
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    /* Close the menu first. Shopflo's login is a full-screen iframe, so an open
       drawer would sit behind it and still be open underneath afterwards. */
    var themeClose = document.querySelector('.close_mn_t4');
    if (themeClose) themeClose.click();

    window.setTimeout(function () {
      var live = shopfloTrigger();
      if (live) live.click();
    }, 260);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest && event.target.closest('.push-menu-btn')) warm();
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.mm_close') : null;
    if (!button) return;
    event.preventDefault();
    var themeClose = document.querySelector('.close_mn_t4');
    if (themeClose) {
      themeClose.click();
      return;
    }
    var mask = document.querySelector('.mask-overlay');
    if (mask) mask.click();
  });

  function start() {
    var canvas = document.getElementById(CANVAS_ID);
    if (!canvas) return;

    var react = function () {
      if (!canvas.classList.contains(OPEN_CLASS)) return;
      loadPicks(canvas);
      focusClose(canvas);
    };

    /* Two things can happen after the drawer opens: the theme injects the
       lazily-rendered body, and the class flips. Either one can arrive first,
       so both are watched and the work is guarded to run once. */
    new MutationObserver(react).observe(canvas, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    react();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
